import React, { useMemo } from "react";

const urlRegexp = /https?:\/\/[^ \n]+/g;
const LOOP_LIMIT = 1000;

function constructNodeListFromTextContent(
  textContent: string
): React.ReactNode[] {
  const nodes: React.ReactNode[] = [];
  let regexMatch: RegExpExecArray | null;
  let pointer = 0;
  let loopCount = 0;
  while (
    (regexMatch = urlRegexp.exec(textContent)) != null &&
    loopCount < LOOP_LIMIT
  ) {
    const text = textContent.substring(pointer, regexMatch.index);
    const matchStr = regexMatch[0]; // url matched
    // append to node list
    nodes.push(text);
    nodes.push(
      <a
        key={regexMatch.index}
        href={matchStr}
        target="_blank"
        rel="noopener noreferrer"
      >
        {matchStr}
      </a>
    );

    // advance pointer
    pointer = regexMatch.index + matchStr.length;

    loopCount += 1;
  }
  // final text segment
  if (textContent.length > pointer) {
    const text = textContent.substring(pointer, textContent.length);
    nodes.push(text);
  }

  return nodes;
}

interface TextWithLinkProps {
  textContent: string;
}

const TextWithLink: React.FC<TextWithLinkProps> = props => {
  const { textContent } = props;

  const nodes = useMemo(() => {
    return constructNodeListFromTextContent(textContent);
  }, [textContent]);

  return <>{nodes}</>;
};

export default TextWithLink;
